module.exports = __webpack_public_path__ + "img/horizontal_7_4_8023.4cb658bb.png";